import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/components/LandingPage";
import PrivacyPolicyPage from "@/components/legal/PrivacyPolicyPage";
import TermsOfServicePage from "@/components/legal/TermsOfServicePage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="noise-overlay">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
